import { query } from "../../utils";
import { /* SENCE_DEV,  */  buildSenceConfigFromMoodle, SENCE_PROD } from "./state";
import otecData from './otecData.json';
import { getCourseOtecData } from "../moodle/courses";

export const SenceMultiOtecValidation = async (args) => {
  let { idSence, auth, session = null, isLogin, nru, courseid } = args;

  // Obtener datos de la OTEC según el código de curso
  const otecResponse = await getCourseOtecData(auth.user.token, courseid);
  console.log(otecResponse)
  
    if (!otecResponse) {
      console.error('No se encontraron datos de OTEC para este curso en Moodle');
      throw new Error('Datos de OTEC no disponibles');
    }

    console.log(`Datos OTEC obtenidos`, otecResponse);

    // Construir configuración con datos de la OTEC desde Moodle
    const SENCE_CONFIG = buildSenceConfigFromMoodle(otecResponse, nru, idSence);

  console.log('Configuración SENCE:', SENCE_CONFIG);
  console.log('Datos usuario:', auth.user);

  let dv = auth.user.username[auth.user.username.length - 1] || null;
  let rut = auth.user.username.slice(0, -1) || null;
  let rut_value = null;
  if (rut) {
    rut_value = `${rut}-${dv}`;
  }

  let form = query("#form-sence");
  let CodSence = query("#CodSence");
  let idSesionAlumno = query("#IdSesionAlumno");
  let runAlumno = query("#RunAlumno");
  let codCurso = query("#CodigoCurso");
  let rutOtec = query("#RutOtec");
  let token = query("#Token");
  let lineaCapacitacion = query("#LineaCapacitacion");
  let urlRetoma = query("#UrlRetoma");
  let urlError = query("#UrlError");

  CodSence.value = SENCE_CONFIG.COD_SENCE;
  idSesionAlumno.value = auth.user.token;
  runAlumno.value = rut_value;
  codCurso.value = SENCE_CONFIG.CODIGO_CURSO;
  rutOtec.value = SENCE_CONFIG.RUT_OTEC;
  token.value = SENCE_CONFIG.TOKEN;
  lineaCapacitacion.value = SENCE_CONFIG.LINEA_CAPACITACION;

  const getBaseUrl = () => {
    const { protocol, hostname, port } = window.location;
    const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ""}/`;
    return baseUrl;
  };

  const codificarBase64 = (texto) => {
    return window.btoa(unescape(encodeURIComponent(texto)));
  };

  const baseUrl = getBaseUrl();
  const baseUrlCodificada = codificarBase64(baseUrl);

  console.log("URL Base:", baseUrl);
  console.log("URL Base codificada en Base64:", baseUrlCodificada);

  if (!isLogin) {
    let idSesionSence = query("#IdSesionSence");
    idSesionSence.value = session.IdSesionSence;

    query("#form-sence").action = SENCE_CONFIG.URL_LOGOUT;
    urlRetoma.value = `${SENCE_CONFIG.URL_RETURN_LOGOUT}?u=${baseUrlCodificada}`;
    urlError.value = `${SENCE_CONFIG.URL_LOGOUT_ERROR}?u=${baseUrlCodificada}`;
  } else {
    query("#form-sence").action = SENCE_CONFIG.URL_LOGIN;
    urlRetoma.value = `${SENCE_CONFIG.URL_RETURN_LOGIN}?u=${baseUrlCodificada}`;
    urlError.value = `${SENCE_CONFIG.URL_LOGIN_ERROR}?u=${baseUrlCodificada}`;
  }

  console.log('sence multi otec submitting')
  console.log({
   /*  form, */
    CodSence: CodSence.value,
    idSesionAlumno: idSesionAlumno.value,
    runAlumno: runAlumno.value,
    codCurso: codCurso.value,
    rutOtec: rutOtec.value,
    token: token.value,
    lineaCapacitacion: lineaCapacitacion.value,
    urlRetoma: urlRetoma.value,
    urlError: urlError.value
  });

  form.submit();
};

export const SenceValidation = (args) => {
  let { idSence, auth, session = null, isLogin, nru } = args;

  console.log(auth.user)
  // ! caso de cambio de idnumber por username
  /* let dv = auth.user.idnumber[auth.user.idnumber.length - 1] || null;
  let rut = auth.user.idnumber.slice(0, -1) || null; */
  let dv = auth.user.username[auth.user.username.length - 1] || null;
  let rut = auth.user.username.slice(0, -1) || null;
  let rut_value = null;
  if (rut) {
    rut_value = `${rut}-${dv}`;
  }

  let form = query("#form-sence");
  let CodSence = query("#CodSence");
  let idSesionAlumno = query("#IdSesionAlumno");
  let runAlumno = query("#RunAlumno");
  let codCurso = query("#CodigoCurso");

  CodSence.value = idSence;
  idSesionAlumno.value = auth.user.token;
  runAlumno.value = rut_value; // todo rut_value;
  codCurso.value = nru;

  if (!isLogin) {
    // Función para obtener la URL base
    const getBaseUrl = () => {
      const { protocol, hostname, port } = window.location;
      // Construir la URL base con el puerto si existe
      const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ""}/`;
      return baseUrl;
    };
    // Función para codificar en Base64 considerando caracteres no ASCII
    const codificarBase64 = (texto) => {
      return window.btoa(unescape(encodeURIComponent(texto)));
    };
    // Ejecutar cuando se cargue la aplicación
    const baseUrl = getBaseUrl();
    const baseUrlCodificada = codificarBase64(baseUrl);

    console.log("URL Base:", baseUrl);
    console.log("URL Base codificada en Base64:", baseUrlCodificada);

    let idSesionSence = query("#IdSesionSence");
    idSesionSence.value = session.IdSesionSence;
    /*     query("#form-sence").action = SENCE_DEV.URL_LOGOUT;
    query("#UrlRetoma").value = SENCE_DEV.URL_RETURN_LOGOUT;
    query("#UrlError").value = SENCE_DEV.URL_LOGOUT_ERROR; */
    query("#form-sence").action = SENCE_PROD.URL_LOGOUT;
    query("#UrlRetoma").value = `${SENCE_PROD.URL_RETURN_LOGOUT}?u=${baseUrlCodificada}`;
    query("#UrlError").value = `${SENCE_PROD.URL_LOGOUT_ERROR}?u=${baseUrlCodificada}`;
  }

  console.log({
    //rut_value, // todo uncomment ;
    form,
    CodSence: CodSence.value,
    idSesionAlumno: idSesionAlumno.value,
    runAlumno: runAlumno.value,
    codCurso: codCurso.value,
  });

  form.submit();
};
/* export const SenceValidation = (idSence, auth, sence = null, isLogin) => {
  const dv = auth.user.idnumber[auth.user.idnumber.length - 1];
  const rut = auth.user.idnumber.slice(0, -1);
  const rut_value = `${rut}-${dv}`;
  const form = document.querySelector("#form-sence");
  const CodSence = document.querySelector("#CodSence");
  const idSesionAlumno = document.querySelector("#IdSesionAlumno");
  const runAlumno = document.querySelector("#RunAlumno");

  CodSence.value = idSence;
  idSesionAlumno.value = auth.user.token;
  runAlumno.value = rut_value;

  if (!isLogin) {
    let idSesionSence = document.querySelector("#IdSesionSence");
    idSesionSence.value = sence.IdSesionSence;
    document.querySelector("#form-sence").action = SENCE_PROD.URL_LOGOUT;
    document.querySelector("#UrlRetoma").value = SENCE_PROD.URL_RETURN_LOGOUT;
    document.querySelector("#UrlError").value = SENCE_PROD.URL_LOGOUT_ERROR;
  }

  form.submit();
}; */



/**
 * Obtiene los datos de la OTEC según el código de curso
 * @param {string} codCurso - Código del curso
 * @returns {Promise<Object|null>} Datos de la OTEC o null si no existe
 */
export const getOtecDataByCourse = async (codCurso) => {
  try {
    // Simular delay de red
    await new Promise(resolve => setTimeout(resolve, 300));
    
    let result = null;
    
    // Buscar en qué OTEC y curso está el código solicitado
    for (const otec of otecData.otecs) {
      for (const curso of otec.cursos) {
        if (curso.codCurso.includes(codCurso)) {
          // Encontramos el curso, construimos un objeto con todos los datos necesarios
          result = {
            rutOtec: otec.rutOtec,
            lineaCapacitacion: otec.lineaCapacitacion,
            token: otec.token,
            codSence: curso.codSence,
            codCurso: codCurso
          };
          break;
        }
      }
      if (result) break;
    }
    
    if (!result) {
      console.warn(`No se encontró OTEC para el curso: ${codCurso}`);
      return null;
    }
    
    return result;
  } catch (error) {
    console.error('Error al obtener datos de OTEC:', error);
    throw error;
  }
};

/**
 * Cuando esté listo el endpoint real, reemplazar por:
 */
// export const getOtecDataByCourse = async (codCurso) => {
//   try {
//     const response = await fetch(`/api/sence/otec/${codCurso}`);
//     if (!response.ok) throw new Error('Error al obtener datos de OTEC');
//     return await response.json();
//   } catch (error) {
//     console.error('Error al obtener datos de OTEC:', error);
//     throw error;
//   }
// };


